import jcdecauxLogo from 'assets/img/jcdecaux_logo.png';

export const Header: React.FC = () => {
  return (
    <header
      className="w-full pb-6 md:px-6 md:pt-6 text-primary-50 sub-header-base relative top-0"
      data-test-id="public-campaign-plan-header"
    >
      <div className="bg-jcd-blue md:rounded-2xl md:px-7">
        <div className="max-w-7xl mx-auto px-8 flex flex-row justify-between items-center">
          <img src={jcdecauxLogo} alt="JCDecaux" className="h-20 w-auto flex-shrink-0" />
        </div>
      </div>
    </header>
  );
};
